import { accounts } from '@/mocks/wedding';
import { copyText } from '@/lib/share';
import { useToast } from '@/components/wedding/ToastProvider';

const PANEL_BG =
  'https://readdy.ai/api/search-image?query=Soft%20still%20life%20of%20cream%20dried%20flowers%2C%20a%20linen%20envelope%20and%20a%20small%20gift%20box%20on%20a%20dark%20walnut%20table%2C%20warm%20cinematic%20light%2C%20moody%20muted%20warm%20brown%20tones&width=2400&height=1350&seq=wed-panel-account&orientation=landscape';

export default function AccountPanel() {
  const toast = useToast();

  const handleCopy = async (number: string, bank: string) => {
    const ok = await copyText(number);
    toast.show(ok ? `${bank} 계좌번호를 복사했어요` : '복사에 실패했어요. 길게 눌러 복사해 주세요');
  };

  return (
    <section className="panel" data-side="right" id="accounts">
      <img className="panel-bg" src={PANEL_BG} alt="마른 꽃과 편지 봉투가 놓인 나무 테이블" data-parallax="0.32" />
      <div className="panel-veil" aria-hidden="true" />
      <div className="panel-copy" data-parallax="-0.08">
        <p className="stamp" data-reveal>
          06 — 마음 전하실 곳
        </p>
        <h2 data-reveal>
          함께하지 못하는 마음,
          <br />
          <em className="accent">이곳에</em> 담아 주세요
        </h2>
        <p className="sub" data-reveal>
          축하의 마음을 전하고 싶으신 분들을 위해 계좌를 안내드립니다. 보내 주신 마음은 오래도록
          간직하겠습니다.
        </p>

        <div className="account-grid">
          {accounts.map((acc) => (
            <article className="card" key={acc.side} data-reveal>
              <h3 className="card-title">
                <span className="role">{acc.side}</span>
                {acc.bank}
              </h3>
              <p className="account-num">{acc.number}</p>
              <p className="card-meta">예금주 {acc.holder}</p>
              <div className="card-actions">
                <button
                  type="button"
                  className="icon-btn"
                  onClick={() => handleCopy(acc.number, acc.bank)}
                >
                  <i className="ri-file-copy-line" aria-hidden="true" />
                  계좌번호 복사
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}